import React from "react";
import cont from "../assets/privacy.json";
import contEn from "../assets/privacy_en.json";
import contJa from "../assets/privacy_ja.json";
import { Textarea, Flex } from "@chakra-ui/react";
import { Header1 } from "../components/Header";
import { Dialog } from "../components/Dialog";
import { Large } from "../components/Type";
import { SingleFormAppShell } from "../components/SingleFormAppShell";
import { Trans, t, msg } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { loadCatalog } from "../i18n";
import Head from "../components/Head";

export async function getStaticProps({ params, ...ctx }) {
  const translation = await loadCatalog(ctx.locale);
  return { props: { translation } };
}

const Privacy = () => {
  const { privacy } = cont;
  const { privacy_en } = contEn;
  const { privacy_ja } = contJa;

  const { i18n } = useLingui();

  const privacyLocalized = (() => {
    switch (i18n.locale) {
      case "id":
        return privacy;
      case "ja":
        return privacy_ja;
      case "en":
        return privacy_en;
      default:
        return privacy;
    }
  })();

  return (
    <>
    <Head title={t`Kebijakan Privasi`} description={t`Pelajari cara Saweria menjaga privasi dan melindungi informasi pribadi kamu untuk memastikan pengalaman pengguna yang aman dan tepercaya.`}></Head>
    <SingleFormAppShell title={t`Kebijakan Privasi`}>
      <Flex
        paddingX={["4", 0, 0]}
        alignItems="center"
        justifyContent="center"
        minH="100vh"
        direction="column"
      >
        <Flex justifyContent="center" direction="column">
          <Header1 />
          <Dialog w={["100%"]} marginTop={3}>
            <Large m={3} alignSelf="center">
              <Trans>Kebijakan Privasi</Trans>
            </Large>
            <Textarea
              h={"50vh"}
              backgroundColor="transparent"
              variant="flused"
              disabled
              value={privacyLocalized}
            ></Textarea>
          </Dialog>
        </Flex>
      </Flex>
    </SingleFormAppShell>
    </>
  );
};

export default Privacy;
